import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  CurrentTier as CurrentTierComponent,
  CurrentTierProps,
} from "../../components/CurrentTier/CurrentTier";
import { getRewardStats } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getRewardStats as getRewardStatsSelector,
} from "../../reducers/methods";

interface CurrentTierContainerProps extends CurrentTierProps {
  campaignId: string;
  getRewardStats: typeof getRewardStats;
  rewardStats: StoreState["reward"]["rewardStats"];
}

class CurrentTier extends React.PureComponent<CurrentTierContainerProps> {
  componentDidMount() {
    const { data, campaignId, getRewardStats, rewardStats } = this.props;
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      const userEmailAddress = get(data, "customer.email");
      const rewardStatsRetrieved = get(rewardStats, "retrieved") !== false;

      if (campaignId && userEmailAddress && !rewardStatsRetrieved) {
        getRewardStats({ campaignId, email: userEmailAddress });
      }
    }
  }

  render() {
    // tslint:disable-next-line:no-any
    return <CurrentTierComponent {...(this.props as any)} />;
  }
}

const mapStateToProps = (state: StoreState) => ({
  campaignId: getCampaignId(state),
  rewardStats: getRewardStatsSelector(state),
});

export default connect(mapStateToProps, { getRewardStats })(CurrentTier);
